import { http } from "./common";

export const GetPatientDetails = async (claimId) => {
    const json = await http.get('/api/v1/PatientDetail/' + claimId);
    return json;
}

export const fetchResources = async (url, patiendId) => {
    const json = await http.get(url + patiendId);
    return json;
}